export default __webpack_public_path__ + "static/media/syncCompleted.b84ffa59.svg";